// API Configuration
// This file centralizes all API endpoints
// In Docker, REACT_APP_API_URL will be set via environment variable

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    USER_LOGIN: `${API_BASE_URL}/api/auth/user/login`,
    INTERN_LOGIN: `${API_BASE_URL}/api/auth/intern/login`,
    ADMIN_LOGIN: `${API_BASE_URL}/api/auth/admin/login`,
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    USER_REGISTER: `${API_BASE_URL}/api/auth/user/register`,
    INTERN_REGISTER: `${API_BASE_URL}/api/auth/intern/register`,
    ADMIN_REGISTER: `${API_BASE_URL}/api/auth/admin/register`,
    CHANGE_PASSWORD: (uid) => `${API_BASE_URL}/api/auth/change-password/${uid}`,
  },
  // User endpoints
  USERS: {
    BASE: `${API_BASE_URL}/api/users`,
    PROFILE: `${API_BASE_URL}/api/users/profile`,
    DISPLAY: (id) => `${API_BASE_URL}/api/users/display/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/api/users/update/${id}`,
    UPLOAD_PROFILE_PICTURE: (id) => `${API_BASE_URL}/api/users/upload-profile-picture/${id}`,
  },
  // Events endpoints
  EVENTS: {
    BASE: `${API_BASE_URL}/api/events`,
    GET_ALL: `${API_BASE_URL}/api/events/getall`,
    CANCEL: (id) => `${API_BASE_URL}/api/events/cancel/${id}`,
  },
  // Intern endpoints
  INTERNS: {
    BASE: `${API_BASE_URL}/api/interns`,
  },
  // Tasks endpoints
  TASKS: {
    BASE: `${API_BASE_URL}/api/tasks`,
    BY_ID: (id) => `${API_BASE_URL}/api/tasks/${id}`,
  },
  // Daily logs endpoints
  DAILY_LOGS: {
    BASE: `${API_BASE_URL}/api/daily-logs`,
    BY_ID: (id) => `${API_BASE_URL}/api/daily-logs/${id}`,
    BY_INTERN: (internId) => `${API_BASE_URL}/api/daily-logs/intern/${internId}`,
  },
  // Feedback endpoints
  FEEDBACK: {
    BASE: `${API_BASE_URL}/api/feedback`,
  },
  // File upload endpoints
  FILE_UPLOADS: {
    BASE: `${API_BASE_URL}/api/file-uploads`,
  },
  // Admin endpoints
  ADMIN: {
    BASE: `${API_BASE_URL}/api/admin`,
    ACCOUNTS: `${API_BASE_URL}/api/admin/accounts`,
  },
  // Help endpoints
  HELP: {
    BASE: `${API_BASE_URL}/api/help`,
    CREATE: `${API_BASE_URL}/api/help/create`,
    USER: (uid, statusFilter) => `${API_BASE_URL}/api/help/user/${uid}/${statusFilter}`,
    UPDATE: (id) => `${API_BASE_URL}/api/help/update/${id}`,
    CANCEL: (id) => `${API_BASE_URL}/api/help/cancel/${id}`,
  },
  // Stats endpoints
  STATS: {
    BASE: `${API_BASE_URL}/api/stats`,
  },
  VOLUNTEERS: {
    GET_ALL: `${API_BASE_URL}/api/volunteers`,
    TOGGLE_AVAILABILITY: (id) => `${API_BASE_URL}/api/volunteers/${id}/availability`,
    STATUS_HISTORY: (id) => `${API_BASE_URL}/api/volunteers/${id}/status-history`,
  },
  VISITORS: {
    REGISTER: `${API_BASE_URL}/api/visitors/register`,
    GET_ALL: `${API_BASE_URL}/api/visitors`,
    STATS: `${API_BASE_URL}/api/visitors/stats`,
    DELETE_VISIT: (id) => `${API_BASE_URL}/api/visitors/visits/${id}`,
    GROUP_MEMBERS: (visitId) => `${API_BASE_URL}/api/visitors/visits/${visitId}/group-members`,
    MANUAL_ENTRY: `${API_BASE_URL}/api/visitors/manual-entry`,
  },
};

// Export the base URL for direct use if needed
export default API_BASE_URL;

